import React from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup } from "uikit/components";
import { useRegionSchoolsAttendance } from "hooks/attendance";
import { BackLink } from "components";
import styles from "./RegionSchoolsAttendancePage.module.styl";
import RegionSchoolsAttendanceView from "components/regionSummary/RegionSchoolsAttendanceView/RegionSchoolsAttendanceView";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";
import { Helmet } from "react-helmet-async";

export default function RegionSchoolsAttendancePage() {
    const { regionId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useRegionSchoolsAttendance(regionId);

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Посещаемость: ${data.regionName}`}
                    />
                    <meta name="application-name" content={`Посещаемость: ${data.regionName}`} />
                </Helmet>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/region-summary/${regionId}`}
                        text={"Назад к показателям"}
                        name={"back_link"}
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="region-school-attendance-header">
                    Посещаемость: {data.regionName}
                </Heading>
                <RegionSchoolsAttendanceView
                    regionId={Number(regionId)}
                    schoolsAttendance={data.schoolsAttendance}
                />
            </>
        );
    }
}
